import { useState } from "react";
import { Copy, Check } from "lucide-react";
import { Button, Card } from "../../components/ui.js";

const BULLETS = [
  "maitv bundles no CDN; for global audiences, front each node's HLS/LL-HLS playback host with a CDN.",
  "Origin = the node's Caddy HTTPS endpoint; preserve the Host header.",
  "Cache .m3u8 manifests 1-2s (honor origin cache headers).",
  "Cache .ts/.m4s segments 10-30s, immutable.",
  "Do NOT cache /whep (WebRTC) or FLV — those stay on the origin.",
  "Viewers use the CDN host for HLS; WHEP and FLV always go to the node origin.",
];

export function CdnHintPanel() {
  const [copied, setCopied] = useState(false);

  async function copy() {
    await navigator.clipboard.writeText(
      BULLETS.map((b) => `• ${b}`).join("\n"),
    );
    setCopied(true);
    window.setTimeout(() => setCopied(false), 1500);
  }

  return (
    <Card
      title="CDN guidance"
      actions={
        <Button variant="secondary" onClick={copy}>
          {copied ? (
            <Check className="h-4 w-4 text-emerald-400" />
          ) : (
            <Copy className="h-4 w-4" />
          )}
          Copy
        </Button>
      }
    >
      <ul className="space-y-2 text-sm text-muted-foreground">
        {BULLETS.map((b) => (
          <li key={b} className="flex gap-2.5">
            <span className="mt-2 h-1 w-1 shrink-0 rounded-full bg-primary/70" />
            <span>{b}</span>
          </li>
        ))}
      </ul>
    </Card>
  );
}
